import React from 'react';
// import ComingSoon from './ComingSoon';
import InsideHeader from './InsideHeader';
import Footer from './Footer';
let { appname, lambda } = window.app;

const Terms = () => {

  return (
    <div id="innerPage" className='inner_page'>
    <InsideHeader id="insideHeader" flag={true} />
    <div id="contentBlock" className='content_block'>
        <div id="content" className='content'>
            <h1 id="termsOfUseHeading">Terms of Use</h1>

            <h3 id="effectiveDate">Effective Date: 11-22-2024</h3>
            <p id="welcomeText">Welcome to shareclix.app ("the Service"). These Terms of Use ("Terms") govern your use of www.shareclix.app, including its mobile application, website, and related services (collectively referred to as the "Platform"). By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree, you may not access or use the Platform.</p>
            
            <h4 id="eligibilityHeading">Eligibility:</h4>
            <ul id="eligibilityList">
                <li id="eligibilityAge">You must be at least 13 years old (or the minimum age required in your jurisdiction) to use the Platform.</li>
                <li id="eligibilityAccuracy">By using the Platform, you confirm that the information you provide is accurate and complete.</li>
            </ul>

            <h4 id="accountRegistrationHeading">Account Registration and Security:</h4>
            <ul id="accountSecurityList">
                <li id="accountCreation">You must create an account to access certain features of the Platform.</li>
                <li id="accountResponsibility">You are responsible for safeguarding your account credentials and agree not to share them with others.</li>
                <li id="accountNotification">You must notify us immediately if you suspect unauthorized access to your account.</li>
            </ul>

            <h4 id="userContentHeading">User Content:</h4>
            <ul id="userContentList">
                <li id="contentOwnership">Ownership: You retain ownership of the photos, videos, and other materials ("User Content") that you upload to the Platform.</li>
                <li id="contentLicense">License: By uploading User Content, you grant shareclix.app a worldwide, non-exclusive, royalty-free license to use, store, display, and distribute your content for purposes of operating and improving the Platform.</li>
                <li id="contentResponsibility">Responsibility: You are solely responsible for the legality and appropriateness of your User Content.</li>
                <li id="contentRestrictions">Restrictions: You may not upload content that:</li>
            </ul>
            <p id="prohibitedContentText">Violates copyright, trademark, or other intellectual property rights. <br />
              Contains explicit, violent, or otherwise objectionable material.<br />
              Harms others, promotes hate speech, or violates applicable laws.</p>
            
            <h4 id="prohibitedActivitiesHeading">Prohibited Activities:</h4>
            <p id="prohibitedActivitiesText">When using the Platform, you agree not to:</p>
            <p id="prohibitedText">Violate laws or regulations. <br />
              Post false, misleading, or harmful content. <br />
              Engage in activities that disrupt the Platform or its users. <br />
              Use bots, scrapers, or other automated tools without our consent.</p>

            <h4 id="privacyHeading">Privacy:</h4>
            <p id="privacyText">Your use of the Platform is governed by our Privacy Policy, which describes how we collect, use, and share your personal information. By using the Platform, you consent to our data practices.</p>

            <h4 id="intellectualPropertyHeading">Intellectual Property:</h4>
            <ul id="intellectualPropertyList">
                <li id="intellectualPropertyOwnership">All content on the Platform, excluding User Content, is the property of shareclix.app or its licensors.</li>
                <li id="intellectualPropertyUsage">You may not use, copy, or distribute our intellectual property without prior written consent.</li>
            </ul>

            <h4 id="terminationHeading">Termination:</h4>
            <ul id="terminationList">
                <li id="terminationSuspension">We may suspend or terminate your account if you violate these Terms or engage in conduct that harms the Platform or its users.</li>
                <li id="terminationUser">You may terminate your account at any time. Upon termination, your access to the Platform will end, but some data may be retained as required by law.</li>
            </ul>

            <h4 id="disclaimersHeading">Disclaimers:</h4>
            <ul id="disclaimersList">
                <li id="disclaimer1">The Platform is provided "as is" without any warranties, express or implied.</li>
                <li id="disclaimer2">We do not guarantee the availability, accuracy, or security of the Platform.</li>
            </ul>

            <h4 id="limitationOfLiabilityHeading">Limitation of Liability:</h4>
            <ul id="limitationOfLiabilityList">
                <li id="limitationLiability1">To the fullest extent permitted by law, shareclix.app is not liable for any damages, including loss of data, revenue, or profits, arising from your use of the Platform.</li>
                <li id="limitationLiability2">Your sole remedy for dissatisfaction with the Platform is to discontinue its use.</li>
            </ul>

            <h4 id="governingLawHeading">Governing Law and Dispute Resolution:</h4>
            <ul id="governingLawList">
                <li id="governingLaw1">These Terms are governed by the laws of India.</li>
                <li id="governingLaw2">Any disputes arising under these Terms will be resolved in the courts of Jurisdiction.</li>
            </ul>

            <h4 id="changesToTermsHeading">Changes to These Terms:</h4>
            <p id="changesToTermsText">We reserve the right to modify these Terms at any time. Material changes will be communicated to you, and your continued use of the Platform constitutes acceptance of the updated Terms.</p>

            <h4 id="contactUsHeading">Contact Us:</h4>
            <p id="contactUsText">If you have questions about these Terms, please contact us: <br />
              Email: prakash@sanchaninfo.com<br />
              Address: Flat No 101, Sri RK Homes, Marripalem VUDA Layout, Visakhapatnam, India - 530016.</p>
        </div>
    </div>
    <Footer id="footer" />
</div>

  );
};

export default Terms;
